export enum TipoFeriado {
  NAO_PROGRAMADO = 'NAO_PROGRAMADO',
  PROGRAMADO = 'PROGRAMADO',
  PROBLEMAS_ADMINISTRATIVOS = 'PROBLEMAS_ADMINISTRATIVOS',
}
